import React from 'react'

import { Stack } from '@zet/design-system'
import { i18n } from '@zet/localization'

import CreditScore from '../svg/CreditScoreSVG.svg'
import Product from '../svg/product'
import Share from '../svg/share'

const creditScoreInfoListData = [
  {
    id: 'id-1',
    icon: <Share size={44} />,
    title: i18n.t('checkCreditScore.list.text1'),
  },
  {
    id: 'id-2',
    icon: (
      <Stack style={{ width: 44, height: 44 }}>
        <CreditScore />
      </Stack>
    ),
    title: i18n.t('checkCreditScore.list.text2'),
  },
  {
    id: 'id-3',
    icon: <Product size={44} />,
    title: i18n.t('checkCreditScore.list.text3'),
  },
]

export { creditScoreInfoListData }
